/**
 * @fileoverview PUT handler for the "/companies/:company_id/app_group_permission_sets/update_permission_set" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAppGroupPermissionSetsUpdatePermissionSetCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdAppGroupPermissionSetsUpdatePermissionSetProps,
  CompaniesCompanyIdAppGroupPermissionSetsUpdatePermissionSetResult,
} from "./types";

export const putCompaniesCompanyIdAppGroupPermissionSetsUpdatePermissionSet = reactQueryMutationAdapter(
  companiesCompanyIdAppGroupPermissionSetsUpdatePermissionSetCacheKeys,
  (
    props: PutCompaniesCompanyIdAppGroupPermissionSetsUpdatePermissionSetProps
  ): Promise<CompaniesCompanyIdAppGroupPermissionSetsUpdatePermissionSetResult> => {
    return fetch(
      `/companies/${encodeURIComponent(props.companyId)}/app_group_permission_sets/update_permission_set`,
      "PUT",
      props
    );
  }
);
